import { InboxOutlined } from "@ant-design/icons";
import { Progress, Upload } from "antd";
import { Checkbox } from "antd";
import axios from "axios";
import _ from "lodash";
import React, { useState, useRef } from "react";
import { useForm, Controller } from "react-hook-form";
import ReactPlayer from "react-player";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import styled from "styled-components";
import Swal from "sweetalert2";
import { v4 as uuidv4 } from "uuid";

import { ReactComponent as ICON_MEDIA_DELETE } from "@assets/svgs/ICON_MEDIA_DELETE.svg";
import { Button } from "@components/Button";
import ErrorValidate from "@components/ErrorValidate";
import { Icon } from "@components/Icon";
import { StyledInput } from "@components/Input";
import { Text } from "@components/Text";
import {
  COLOR_BLACK,
  COLOR_DARK,
  COLOR_GREEN,
  COLOR_WHITE,
} from "@static/COLORS";
import { generateDragProps } from "@utils/generateDragProps";
import { configHeader } from "@utils/https/configHeader";
import { VALIDATE_RULES } from "@validate/index";

const { Dragger } = Upload;

const FormContainer = styled.form`
  width: 100%;
  height: 100%;
  display: flex;
  position: relative;
  flex-direction: column;
  gap: 2px;
`;

const Line = styled.div`
  width: 100%;
  height: 1px;
  margin-bottom: 8px;
  background-color: rgba(0, 0, 0, 0.1);
`;

const InnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex-grow: 1;
  overflow: scroll;
`;

const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 40px;
`;

const PreviewContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const PreviewItem = styled.div`
  position: relative;
  width: 100%;
  height: 270px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const SectionUpload = styled.div`
  height: 100%;
  margin-bottom: 10px;
`;

const SectionInput = styled.div`
  display: grid;
  gap: 20px;
  /* grid-template-columns: repeat(2, 1fr); */
`;

const ContainerClearButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  right: 10px;
  top: 10px;
  padding: 4px;
  background: ${COLOR_DARK};
  border-radius: 4px;
`;

const LoadingIndicator = styled.div`
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${COLOR_WHITE};
  z-index: 30;
`;

const { REACT_APP_API_ENDPOINT, REACT_APP_REQUEST_TIME_OUT } = process.env;

export const FormUpload = ({
  setMediaList = () => undefined,
  setDataList = () => undefined,
  setIsModalVisible,
  dataList,
  location_id,
  customer_id,
  useInManageBlock = false,
  setIsCloseModal,
  mediaList = {},
}) => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const { control, handleSubmit, setValue } = useForm({
    defaultValues: { extension: null, fileType: null },
  });
  const [fileUpload, setFileUpload] = useState();
  const [thumbnailCreated, setThumbnailCreated] = useState(false);

  const [thumbnail, setThumbnail] = useState(null);
  const [isShare, setIsShare] = useState(false);
  const [progress, setProgress] = useState(0);

  const playerRef = useRef(null);
  const canvasRef = useRef(null);

  const base64ToFile = ({ base64, fileName, mimeType = "image/png" }) => {
    const byteString = atob(base64.split(",")[1]);
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const intArray = new Uint8Array(arrayBuffer);

    for (let i = 0; i < byteString.length; i++) {
      intArray[i] = byteString.charCodeAt(i);
    }

    const blob = new Blob([intArray], { type: mimeType });
    const file = new File([blob], fileName, {
      type: mimeType,
      lastModified: Date.now(),
    });
    file.uid = uuidv4();

    return file;
  };

  const captureThumbnail = () => {
    const player = playerRef?.current?.getInternalPlayer();
    const canvas = canvasRef?.current;
    const ctx = canvas.getContext("2d");

    const width = 640;
    const height = 360;

    canvas.width = width;
    canvas.height = height;

    ctx.drawImage(player, 0, 0, canvas.width, canvas.height);

    const dataUrl = canvas.toDataURL();
    setThumbnail(dataUrl);
  };

  const onHandleCreate = async (fileData) => {
    try {
      setIsLoading(true);
      setIsCloseModal(false);
      const display_name = _.get(fileData, ["display_name"]);
      const extension = _.get(fileData, ["extension"]);
      const type = _.get(fileData, ["fileType"]);
      const duration = _.get(fileData, ["duration"]);
      const size = _.get(fileData, ["fileSize"]);
      const fileKey = _.get(fileData, ["fileKey"]);

      const thumbnailFile = _.chain(type)
        .split("/")
        .first()
        .isEqual("video")
        .value()
        ? base64ToFile({
            base64: thumbnail,
            fileName: `${fileKey}-thumbnail.png`,
          })
        : null;

      const uploadResp = await axios({
        method: "post",
        url: `${REACT_APP_API_ENDPOINT}${"/api/v1/medias-upload-file"}`,
        data: {
          category_customer_id: customer_id,
          location_id,
          display_name,
          extension,
          type,
          duration,
          size,
          file: fileUpload,
          thumbnailFile,
          fileKey,
          is_share: isShare,
        },

        headers: configHeader({ auth: true }),
        timeout: REACT_APP_REQUEST_TIME_OUT,
        onUploadProgress: (progressEvent) => {
          const percentCompleted = Math.round(
            (progressEvent?.loaded * 100) / progressEvent?.total
          );
          // console.log("percentCompleted :>> ", percentCompleted);
          setProgress(percentCompleted);
        },
      });

      const resp = _.get(uploadResp, ["data"]);

      if (_.get(resp, ["status"])) {
        const results = _.chain(resp).get(["result"]).value();
        toast.success("Upload Media Success.");

        if (useInManageBlock) {
          const updateMedia = _.chain(results)
            .thru((media) => {
              const duration = _.chain(media)
                .get(["duration"])
                .toInteger()
                .value();
              const location_id = _.chain(media)
                .get(["location_id"])
                .toInteger()
                .value();
              const category_customer_id = _.chain(media)
                .get(["category_customer_id"])
                .toInteger()
                .value();

              const size = _.chain(media).get(["size"]).toInteger().value();

              return {
                ...media,
                duration,
                location_id,
                category_customer_id,
                size,
              };
            })
            .value();
          const updateMediaList = _.chain(mediaList)
            .flatMap()
            .concat(updateMedia)
            .groupBy((media) => {
              return _.chain(media).get(["type"]).split("/").first().value();
            })
            .value();

          setMediaList(updateMediaList);
        } else {
          const updateData = _.chain(dataList)
            .thru((list) => {
              const resultShare = _.get(results, ["is_share"]) === "true";
              const resultSize = _.chain(results)
                .get(["size"])
                .toInteger()
                .value();
              return [
                {
                  ...results,
                  size: resultSize,
                  isInUse: false,
                  is_share: resultShare,
                },
                ...list,
              ];
            })
            .map((item, index) => {
              return { ...item, key: index + 1, index: index + 1 };
            })
            .value();
          setDataList(updateData);
        }

        setIsModalVisible((prev) => ({ ...prev, isOpen: false }));
      } else {
        console.log("resp :>> ", resp);
      }
    } catch (error) {
      Swal.fire({
        position: "error",
        icon: "error",
        title: "Upload File error",
        showConfirmButton: true,
      });
      setIsCloseModal(true);
    }
    // setIsLoading(false);
  };

  const onHandleClearFile = () => {
    setFileUpload(null);
    setThumbnailCreated(null);
    setThumbnail(null);
  };

  return (
    <FormContainer onSubmit={handleSubmit(onHandleCreate)} autoComplete="off">
      <Line />
      <InnerContainer>
        {!fileUpload && (
          <SectionUpload>
            <Dragger
              {...generateDragProps({
                setFileUpload,
                setValue,
              })}
            >
              <p className="ant-upload-drag-icon">
                <InboxOutlined />
              </p>
              <p className="ant-upload-text">
                Click or drag file to this area to upload
              </p>
            </Dragger>
          </SectionUpload>
        )}
        {fileUpload && (
          <PreviewContainer>
            <PreviewItem>
              {isLoading && (
                <LoadingIndicator>
                  <Progress
                    size="small"
                    percent={progress}
                    type="circle"
                    strokeColor={COLOR_BLACK}
                  />
                </LoadingIndicator>
              )}
              {fileUpload.type.startsWith("image/") ? (
                <img
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "contain",
                  }}
                  src={URL.createObjectURL(fileUpload)}
                  alt={_.get(fileUpload, ["name"], "-")}
                />
              ) : (
                <ReactPlayer
                  ref={playerRef}
                  height={270}
                  url={URL.createObjectURL(fileUpload)}
                  controls
                  onReady={() => {
                    captureThumbnail();
                  }}
                />
              )}
              <ContainerClearButton onClick={() => onHandleClearFile()}>
                <Icon width={"24px"} height={"24px"} isCursor>
                  <ICON_MEDIA_DELETE fill={COLOR_WHITE} />
                </Icon>
              </ContainerClearButton>
            </PreviewItem>
            <SectionInput>
              <Controller
                name="display_name"
                control={control}
                rules={_.get(VALIDATE_RULES, ["required"])}
                render={({ field, fieldState: { error } }) => (
                  <div>
                    <Text
                      color={COLOR_DARK}
                      fontSize="14px"
                      style={{ marginBottom: 4, marginLeft: 4 }}
                    >
                      Name
                    </Text>
                    <StyledInput
                      label="name"
                      {...field}
                      size="large"
                      placeholder="name"
                    />
                    <ErrorValidate justify="start" error={error} />
                  </div>
                )}
              />
            </SectionInput>
          </PreviewContainer>
        )}
        <ButtonContainer>
          <Checkbox
            checked={isShare}
            onChange={() => setIsShare((prev) => !prev)}
          >
            Share
          </Checkbox>
          <Button
            disabled={_.isNil(fileUpload) || isLoading}
            type="submit"
            color={COLOR_GREEN}
            fontColor={COLOR_WHITE}
            fontSize="16px"
            padding="5px 20px"
          >
            Save
          </Button>
        </ButtonContainer>
      </InnerContainer>
      <canvas ref={canvasRef} style={{ display: "none" }} />
    </FormContainer>
  );
};
